export default {
	"perforMeet": {
		"pickMeet": "pickup reservation",
		"prebookStatus": "reservation status",
		"senderAddress": "pickup address",
		"receiverAddress": "receving address",
		"latestDeliveryDt": "requires pickup time",
		"latestReceivedDt": "require delivery time",
		"orderAttachment": "order attachment",
		"togetherMeetTips": "whether to make an appointment together for the orders with the same pickup address",
		"pickUpVehicleInfo": "pickup vehicle information",
		"batchPickMeet": "batch pickup appointment",
		"batchMeet": "batch appointment",
		"batchPickMeetFail": "batch pickup reservation failed",
		"meetFailMsg": "appointment failure information",
		"transportPickAddress": "pickup address",
		"transportReceiverAddress": "receiving address",
		"meetPickTimeTips": "please select the delivery time range!",
		"pleaseSelectNoPickedTips": "please select the orders to be picked up",
		"meetPickTimeRangeTips": "please select the time range of the appointment!",
		"msgTips": "but it did not affect the final appointment results. please check whether the appointment message is delivered offline",
		"carrierNo": "carrier order number",
		"items": "project",
		"sendTime": "shipping time"
	},
	"performGoods": {
		"batchPick": "batch pickup",
		"waitingForPickUp": "to be picked up",
		"shipped": "shipped",
		"pickUpFailed": "failure to pick up the goods",
		"driverHandle": "driver operation",
		"pickUp": "picked up",
		"delivered": "delivered",
		"rePickup": "re-pickup",
		"pickupCompleted": "pickup completed",
		"doBlank": "empty",
		"pickupGoodsTemp": "goods temperature at pickup",
		"weight": "the weight of to be picked up (kg)",
		"goodsQty": "Total items should be picked up",
		"volume": "the volume to be picked up (cubic meter)",
		"packingQty": "the packages to be picked up (kg)",
		"actualWeight": "actual pickup weight",
		"actualVolume": "actual pickup volume",
		"inputPickupInfo": "record pickup details",
		"pickupService": "pickup service",
		"allPackingQty": "the total number of boxes",
		"trackStatus": "track status",
		"thisOrderCreate": "this order generated",
		"abnormalNo": "exceptions",
		"pleaseHandleItInTime": "please handle in time",
		"isBatchPick": "whether to continue to pick up the goods in batch?",
		"batchPickTips": "background processing, you will be notifed you through the system information after the processing is completed. during this period, please do not update pick up/delivery status for orders!",
		"pickupDtTips1": "the pickup completed time cannot be earlier than the [ pickup arrival time, pickup start time]",
		"pickupDtTips2": "the pickup start time cannot be earlier than the [pickup arrival time] or later than [pickup completed time]",
		"pickupDtTips3": "the pickup arrive time cannot be later than [the start time of the pick-up, the complete time of the pick-up]",
		"notOnlyOneTips": "please select at least two shipping orders",
		"waybillStatusRequire": "the state of transportation must be for the state of delivery",
		"laterThanTips": "confirm that the delivery is completed later than",
		"endTimeTips": "the end of the transportation?",
		"pickupArrivalDtTips": "please fill in the pickup arrvial time.",
		"overPickupArrivalDtTips": "the pickup arrvial time must be earlier than the current time.",
		"inputCapacityInfoTips": "please fill in the capacity information.",
		"isSureTips": "are you sure to",
		"emptyTheWaybillTips": "empty the shipping order",
		"vehicleTemperatureTips": "please enter the number between -100 and 100",
		"sureToSubmit": "are you sure to submit?",
		"selectServiceProvider": "Choose a service provider that provides value-added services",
		"serviceProvider": "service provider",
		"serviceWorkload": "Fill in the workload of the value-added services provided",
		"baseService": "basic service",
		"selectTheServiceProvider": "Choose the service provider",
		"service": "Service",
		"inputServiceWorkload": "Fill in the amount of service provided",
		"noServiceInfo": "No service information yet",
		"addedServiceTips": "There are mistakes in the value-added services, please correct them!",
		"baseServiceTips": "There are errors in the basic services, please correct them!"
	},
	"performSendGoods": {
		"batchSendGoods": "Bulk delivery",
		"sendGoodsfaile": "delivery failed",
		"sendGoodsComplete": "Delivery completed",
		"refused": "reject",
		"latestReceivedDt": "Expected arrival time",
		"actualGoodsQty": "Total Items",
		"inputGoodsInfo": "Enter the details of the signed goods",
		"deliveryRemarks": "Shipping Notes",
		"returnTransport": "return shipping",
		"returnOfGoodsTransport": "return",
		"returnOfGoodsAddress": "return address",
		"returnCargoTemperature": "Return cargo temperature",
		"tips1": "Return the rejected goods to the designated address with the assigned vehicle",
		"returnTransportCarInfo": "Fill in the return transportation vehicle information",
		"tips2": "Do you really want to throw away these rejected shipments?",
		"noReturn": "not return",
		"batchDeliveryCompleted": "Bulk delivery completed",
		"sendService": "successful delivery",
		"deliveryBeginDt": "Delivery start time",
		"rejectedGoodsStatus": "Receipt status",
		"tips3": "The delivery completion time cannot be earlier than [delivery arrival time, receiving start time, pickup completion time]",
		"tips4": "Receipt start time cannot be earlier than [delivery arrival time, pick-up completion time] or later than [delivery completion time]",
		"tips5": "The delivery arrival time cannot be later than [receiving start time, Delivery Completion Time] or earlier than [Pickup Completion Time]",
		"successfulExecution": "execute successfully",
		"noInfo": "no information",
		"tips6": "Return Shipment 'Estimated Time of Arrival' must be at 'Delivery Completion Time'",
		"tips7": "then",
		"tips8": "The waybill or non-final waybill generated by rejection is not allowed to be rejected!",
		"tips9": "Delivery completion time is required!",
		"tips10": "Return cargo temperature, please enter a number between -100 and 100 with a maximum of one decimal place",
		"tips11": "Please enter a number between -100 and 100 with a maximum of one decimal place for vehicle temperature",
		"tips12": "Whether to continue bulk delivery",
		"tips13": "Waybill status must be in transit",
		"tips14": "Whether to confirm bulk delivery",
		"tips15": "The quantity of rejected goods and the number of rejected packages must be 0 for the waybill or non-final waybill generated by rejection!",
		"tips16": "Please fill in the receiving weight",
		"tips17": "Please enter a number between -100 and 100 for the delivery temperature",
		"uncollected": "Uncollected",
		"partialRejection": "partial rejection",
		"all": "collect all"
	},
	"performTransit": {
		"trackingNormal": "tracking is normal",
		"orderFinish": "document completed",
		"transshipmentInfo": "Transshipment information",
		"changeCarInfo": "change vehicle information",
		"changeCarTime": "change time",
		"mainLineDeparture": "linehaul departure",
		"trunkTime": "Departure time",
		"trunkArrived": "linehaul arrives",
		"trunkArrivedTime": "Time of arrival",
		"pickupOfArrival": "Pick up to the station",
		"pickupArrivalTime": "Arrival time",
		"distribution": "linehaul delivery",
		"distributionTime": "Delivery departure time",
		"distributionCapacitys": "Delivery vehicle information",
		"changeCar": "change vehicle",
		"transshipment": "transport",
		"monitoringInfo": "Monitoring information",
		"executeInfo": "Implementation",
		"batchCancel": "Cancel in bulk",
		"requirement": "Require",
		"project": "project",
		"packingQty": "Number of packages",
		"volume": "Order volume (cube meters)",
		"weight": "Order weight (kg)",
		"realityInfo": "The actual situation",
		"beginTime": "Actual start time",
		"endTime": "Actual end time",
		"finishLocationQty": "number of sites completed",
		"finishTransportQty": "complete orders",
		"maxTemperature": "maximum temperature",
		"mixTemperature": "lowest temperature",
		"earliestBeginTime": "Earliest start time",
		"latestEndTime": "latest end time",
		"pleaseSelectArrivedTime": "Please select arrival time!",
		"trunkArrivedTips": "This operation is only available for dispatch orders with \"in transit and lineal departure\".",
		"pleaseSelectTrunkTime": "Please select departure time!",
		"trunkArrivedTips2": "This operation is only available for dispatch orders that are \"in transit and have not departed or have not arrived\".",
		"transportNoStatusTips": "Only the waybill with the status of [New/Planned/Pending Pickup] can be selected",
		"uncheckWaybill": "Are you sure you want to uncheck the waybill?",
		"execute": "execution",
		"tips1": "order",
		"tips2": "success",
		"tips3": "fail",
		"tips4": "Reason for failure",
		"tips5": "execution results",
		"tips6": "waybill",
		"tips7": "If it is not in the shipped state, please check the document in the shipped state.",
		"tips8": "Please select the arrival date.",
		"tips9": "Please select a delivery departure time.",
		"tips10": "Please add delivery vehicle information.",
		"warnTips": "Warnings and exceptions",
		"warnInfo": "Warning information",
		"warningTimeBegin": "Warning time",
		"cancelTime": "release time"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/perform/perform.js